import {ChangeDetectionStrategy, Component, HostListener} from '@angular/core'
import {ProDirectoryPageService} from './pro-directory-page.service'
import {TranslocoService} from '@ngneat/transloco'
import {Observable, of} from 'rxjs'
import {
  getTranslatablePageMetadataKeys,
  PageComponent,
  PageMetadata,
  translatePageMetadata,
} from '../../../core/seo/page-metadata'
import {take} from 'rxjs/operators'
import {OptableLayout} from '../../../core/components/layout/optable-layout.interface'
import {PUBLIC_ROUTES} from '../../../shared/routing/public.routes'
import {LinkService} from '../../../core/i18n/link.service'
import {ProDirectoryPageContentService} from '../../../core/content/services/pro-directory-page-content.service'
import {IndustryOverviewPageContentService} from '../../../core/content/services/industry-overview-page-content.service'
import {Language} from '../../../core/i18n/language'

@Component({
  templateUrl: './pro-directory-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ProDirectoryPageService, ProDirectoryPageContentService, IndustryOverviewPageContentService],
  standalone: false,
})
export class ProDirectoryPageComponent extends PageComponent implements OptableLayout {
  // "static" industries should only load once the first time and not be influenced by filters, sorting etc.
  protected readonly industriesStatic$ = this.proDirectoryPageService.industries$.pipe(take(1))
  protected readonly industries$ = this.proDirectoryPageService.industries$
  protected readonly top10Offerings$ = this.proDirectoryPageService.top10Offerings$
  protected readonly page$ = this.contentService.getProDirectoryPage()
  protected showStickyFooter = false
  readonly optOutOfLayout = true

  constructor(
    protected readonly proDirectoryPageService: ProDirectoryPageService,
    private readonly translocoService: TranslocoService,
    private readonly contentService: ProDirectoryPageContentService,
    private readonly linkService: LinkService,
  ) {
    super()
  }

  @HostListener('window:scroll', ['$event'])
  onScroll(event) {
    this.showStickyFooter = event.target?.defaultView?.scrollY > 400
  }

  getPageMetadata(): Observable<PageMetadata> {
    const metadata = getTranslatablePageMetadataKeys('proDirectoryPage')
    return translatePageMetadata(this.translocoService, {...metadata})
  }

  getPageAvailableLanguages(): Observable<Language[]> {
    return of(Object.values(Language))
  }

  navigateToAboutUsPage(): Promise<boolean> {
    return this.linkService.navigateTo(PUBLIC_ROUTES.ABOUT_US)
  }

  protected readonly take = take
}
